import React from 'react';
import styled, { css } from 'styled-components';

import { Image } from '@lt/components';

import flightMapSrc from 'src/images/homepage_map/homepage_map.webp';
import flightMapFallback from 'src/images/homepage_map/homepage_map.png';

import { isSSR } from 'src/helpers/ssr';

import Header from 'src/components/Header';
import Footer from 'src/components/Footer';
import FooterAppBanners from 'src/components/Layout/components/FooterAppBanners';
import HeaderBanner from 'src/components/Banners/HeaderBanner';
import SearchForm from '../SearchForm';
import AdfoxGalleryBanner from '../AdfoxGalleryBanner';
import StatisticsWidget from '../StatisticsWidget';
import HomeLtBottomPromo from '../MobileSearchBlock/components/HomeLtBottomPromo';
import CountriesList from '../CountriesList';
import Relinking from '../Relinking';
import DynamicDataWrapper from '../MobileSearchBlock/components/DynamicDataWrapper';

import type { PropsFromRedux as IDesktop } from '.';
import { WLHeaderBackground } from '../Header/WL/WLHeaderBackground';
import WLHeaderDescription from '../Header/WL/WLHeaderDescription';

const Desktop = ({
  isWhitelabel,
  isStatisticWidgetDisabled,
}: IDesktop): JSX.Element => (
  <>
    <HeadContainer>
      {!isSSR && (
        <>
          {isWhitelabel ? (
            <WLHeaderBackground />
          ) : (
            <FlightMap src={flightMapSrc} fallback={flightMapFallback} />
          )}
          <HeadContentContainer>
            <HeaderBanner />
            <HeaderShadow $isWhitelabel={isWhitelabel}>
              <Container>
                <Header />
              </Container>
            </HeaderShadow>
            <Container>
              {isWhitelabel ? <WLHeaderDescription /> : null}
              <DynamicDataWrapper>
                <SearchForm />
              </DynamicDataWrapper>
            </Container>
          </HeadContentContainer>
        </>
      )}
    </HeadContainer>
    {!isWhitelabel && <AdfoxGalleryBanner />}
    <ContentContainer>
      {!isStatisticWidgetDisabled && <StatisticsWidget />}
      <Relinking isMobile={false} />
      {!isWhitelabel && (
        <>
          <HomeLtBottomPromo />
          <CountriesList />
        </>
      )}
    </ContentContainer>
    <FooterAppBanners />
    <Footer />
  </>
);

const ContentContainer = styled.div`
  max-width: 1220px;
  margin: 0 auto;
`;

const HeadContainer = styled.div`
  position: relative;
  width: 100%;
  height: 510px;
  background-color: lightblue;
`;

const HeadContentContainer = styled.div`
  left: 0;
  right: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const HeaderShadow = styled.div<{ $isWhitelabel: boolean }>`
  padding-top: 10px;
  ${({ $isWhitelabel }) =>
    $isWhitelabel
      ? css`
          background: linear-gradient(
            rgba(0, 0, 0, 0.5) 28.65%,
            rgba(0, 0, 0, 0) 100%
          );
        `
      : css`
          background: linear-gradient(
            180deg,
            rgba(234, 234, 234, 0.8) 28.65%,
            rgba(242, 242, 242, 0) 100%
          );
        `};
  position: relative;
  z-index: 502;
  /**
   * 501 - z-index сиги
   */
`;

const Container = styled.div`
  width: 100%;
  position: relative;

  margin: 0 auto;
  max-width: 1200px;
  min-width: 1100px;
`;

const FlightMap = styled(Image)`
  display: block;
  position: relative;

  object-fit: cover;

  height: 100%;
  width: 100%;
`;

export default Desktop;
